import React, { useState, useRef } from 'react';
import { Box, TextField } from '@mui/material';

const OtpInput = ({ length, onComplete }) => {
  const [otp, setOtp] = useState(new Array(length).fill(''));
  const inputsRef = useRef([]);

  const handleChange = (value, index) => {
    const digit = value.slice(-1);
    if (isNaN(digit)) return;

    const newOtp = [...otp];
    newOtp[index] = digit;
    setOtp(newOtp);

    if (digit !== '' && index < length - 1) {
      inputsRef.current[index + 1].focus();
    }

    const otpValue = newOtp.join('');
    if (otpValue.length === length) {
      onComplete(otpValue);
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      e.preventDefault();
      const newOtp = [...otp];
      newOtp[index - 1] = '';
      setOtp(newOtp);
      inputsRef.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData('text').slice(0, length);
    if (!/^\d+$/.test(pasteData)) return;

    const newOtp = [...otp];
    pasteData.split('').forEach((char, index) => {
      if (index < length) {
        newOtp[index] = char;
      }
    });
    setOtp(newOtp);

    const lastFilledIndex = Math.min(pasteData.length - 1, length - 1);
    if (lastFilledIndex >= 0) {
      inputsRef.current[lastFilledIndex].focus();
    }

    if (pasteData.length >= length) {
      onComplete(newOtp.join(''));
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: { xs: '4px', sm: '8px' }, 
        justifyContent: 'center',
      }}
    >
      {otp.map((digit, index) => (
        <TextField
          key={index}
          inputProps={{
            maxLength: 1,
            style: { textAlign: 'center' },
          }}
          value={digit}
          onChange={(e) => handleChange(e.target.value, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          onPaste={handlePaste}
          inputRef={(el) => (inputsRef.current[index] = el)}
          sx={{
            width: { xs: '2.5rem', sm: '3rem' }, 
          }}
        />
      ))}
    </Box>
  );
};

export default OtpInput;
